import { Anchor, Text } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import { Event } from 'typings'
import { useAnalytics } from 'use-analytics'
import { messages } from './messages'

export function Empty() {
  const { $t } = useIntl()
  const { track } = useAnalytics()

  const handleOnClick = () => {
    track(Event.OPT_IN_LEARN_MORE_CLICK, {
      link: $t(messages.moreInformation),
    })
  }

  return (
    <Text variant="body" tone="secondary">
      <FormattedMessage
        {...messages.view.description}
        values={{
          a: (content: any) => (
            <Anchor
              target="_blank"
              href={$t(messages.moreInformation)}
              onClick={handleOnClick}
            >
              {content}
            </Anchor>
          ),
        }}
      />
    </Text>
  )
}
